import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { FaUserAlt } from 'react-icons/fa';
import { fetchApi } from '../../services/api';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import TopPage from '../../components/TopPage';
import ListTestes from '../../components/ListTestes';
import Loading from '../../components/Loading';
import host from '../../services/host';
import { getStorage } from '../../utils/storage';
import { getLink } from '../../services/host';

class InstitucionalTestesPaciente extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id_paciente:
        props.match.params.id_paciente !== undefined
          ? props.match.params.id_paciente
          : null,
      id_pesquisador:
        props.match.params.id_pesquisador !== undefined
          ? props.match.params.id_pesquisador
          : null,
      nome: '',
      nascimento: '',
      idade: '',
      escolaridade: '',
      testes: [],
      ultimo: '',
      successMessages: [],
      errorMessages: [],
      isLoading: false,
      id_teste: null,
      teste_remoto: null,
      token: getStorage('token'),
    };
  }

  componentDidMount() {
    document.title = `Perfil`;
    window.scrollTo(0, 0);

    if (this.state.id_paciente !== null) {
      this.carregarDados();
    }
  }

  carregarDados() {
    //ativa loading
    this.setState({
      isLoading: true,
      successMessages: [],
      errorMessages: [],
    });

    fetchApi
      .get(
        process.env.REACT_APP_INSTITUCIONAL_PACIENTE_GET,
        this.state.id_pesquisador,
        this.state.id_paciente,
      )
      .then((response) => {
        //esconde loading
        this.setState({
          isLoading: false,
        });

        if (response.data.status === 'success') {
          //mostra mensagem
          this.setState({
            nome: response.data.dados.nome,
            idade: response.data.idade,
            nascimento: response.data.dados.nascimento,
            escolaridade: response.data.dados.escolaridade,
            testes: response.data.testes,
            ultimo: response.data.ultimo,
          });
        } else {
          this.setState({
            id: null,
            errorMessages: response.data.messages,
          });
        }
      })
      .catch((err) => {
        //esconde loading
        this.setState({
          isLoading: false,
          id: null,
          errorMessages: [
            'Ocorreu um erro inexperado. Por favor, tente novamente.',
          ],
        });
      });
  }

  render() {
    return (
      <div>
        <Header />

        <div className="content">
          <TopPage
            title={this.state.nome}
            back={getLink(
              `/pesquisador/${this.state.id_pesquisador}/pacientes`,
            )}
            small={`Data de nascimento: ${this.state.nascimento} - ${this.state.idade}`}
            small3={`Escolaridade: ${this.state.escolaridade}`}
            icon={true}
            exportxls={`${host}/export-all-institucional/pesquisador/${this.state.id_pesquisador}/paciente/${this.state.id_paciente}?token=${getStorage('token')}`}
          >
            <FaUserAlt />
          </TopPage>

          <ListTestes
            testes={this.state.testes}
            id_paciente={this.state.id_paciente}
            readOnly={true}
            baseUrl={`/pesquisador/${this.state.id_pesquisador}/paciente/${this.state.id_paciente}`}
          />
        </div>

        {this.state.id === null && <Redirect to={getLink(`/dashboard`)} />}

        <Footer />

        {this.state.isLoading ? <Loading /> : null}
      </div>
    );
  }
}

export default withRouter(InstitucionalTestesPaciente);
